"use client";

import { c as _c } from "react/compiler-runtime";
import { apiClient } from "@/lib/apiClient";
import { signOut, useSession } from "next-auth/react";
import { useEffect, useRef, useState } from "react";
import Loading from "@/app/loading";
export default function AuthBootstrap(t0) {
  const $ = _c(14);
  const {
    children
  } = t0;
  const {
    data: session,
    status,
    update
  } = useSession();
  const [isTokenReady, setIsTokenReady] = useState(false);
  const initializedTokenRef = useRef(null);
  const sessionRef = useRef(session);
  let t1;
  let t2;
  if ($[0] !== session) {
    t1 = () => {
      sessionRef.current = session;
    };
    t2 = [session];
    $[0] = session;
    $[1] = t1;
    $[2] = t2;
  } else {
    t1 = $[1];
    t2 = $[2];
  }
  useEffect(t1, t2);
  let t3;
  if ($[3] !== session || $[4] !== status || $[5] !== update) {
    t3 = () => {
      if (status === "unauthenticated") {
        apiClient.clearAuthToken();
        initializedTokenRef.current = null;
        setIsTokenReady(true);
        return;
      }
      if (status !== "authenticated") {
        setIsTokenReady(false);
        return;
      }
      if (session?.user?.accessToken && session.user.accessToken === initializedTokenRef.current) {
        setIsTokenReady(true);
        return;
      }
      const initializeToken = async () => {
        const accessToken = session?.user?.accessToken;
        const expiresAt = session?.user?.expires_at;
        if (!accessToken || !expiresAt) {
          apiClient.clearAuthToken();
          await signOut({
            redirect: false
          });
          window.location.href = "/";
          return;
        }
        apiClient.setAuthToken(accessToken, expiresAt);
        apiClient.setSessionUpdateCallback(async t4 => {
          const {
            accessToken: newToken,
            expiresAt: newExpiry
          } = t4;
          initializedTokenRef.current = newToken;
          await update({
            ...sessionRef.current,
            user: {
              ...sessionRef.current?.user,
              accessToken: newToken,
              expires_at: newExpiry
            }
          });
        });
        setIsTokenReady(true);
      };
      initializeToken();
    };
    $[3] = session;
    $[4] = status;
    $[5] = update;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  const t4 = session?.user?.accessToken;
  const t5 = session?.user?.expires_at;
  let t6;
  if ($[7] !== status || $[8] !== t4 || $[9] !== t5) {
    t6 = [t4, t5, status];
    $[7] = status;
    $[8] = t4;
    $[9] = t5;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  useEffect(t3, t6);
  if (status === "loading" || !isTokenReady) {
    let t7;
    if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
      t7 = <Loading />;
      $[11] = t7;
    } else {
      t7 = $[11];
    }
    return t7;
  }
  let t7;
  if ($[12] !== children) {
    t7 = <>{children} </>;
    $[12] = children;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  return t7;
}